import { useStore } from '@tanstack/react-store'
import { authStore, authActions } from '../stores/auth.store'

export function useAuth() {
  const auth = useStore(authStore)
  
  return {
    ...auth,
    ...authActions,
  }
}